import React, { FC } from "react";
import classNames from "classnames/dedupe";
import { Button } from "../../ActionsSelectors/Button";
import { Carousel } from "../../ActionsSelectors/Carousel";
import { Link } from "../../ActionsSelectors/Link";
import { ResponsiveContainer } from "../../Utility/ResponsiveContainer";

export interface ICategoryTilesProps {
  /** Data from Api */
  categoryList: { id: number; title: string; url: string }[];
  /** Custom styles */
  classes?: { root?: string };
}

const CategoryTiles: FC<ICategoryTilesProps> = ({ categoryList, classes }) => {
  const rootClasses = classNames(classes?.root);

  const renderList = ({ id, url, title }) => (
    <Link key={id} href={url} classes={{ root: "text-decoration-none" }}>
      <Button variant="tag" classes={{ root: "me-4 mb-4" }}>
        {title}
      </Button>
    </Link>
  );

  return (
    <div className={rootClasses}>
      <Carousel
        variant="simple-carousel"
        classes={{ root: "p-2 d-block d-sm-none" }}
      >
        {categoryList.map((category) => {
          return renderList({ ...category });
        })}
      </Carousel>
      <ResponsiveContainer classes={{ root: "p-2 d-none d-sm-block" }}>
        {categoryList.map((category) => {
          return renderList({ ...category });
        })}
      </ResponsiveContainer>
    </div>
  );
};

export default CategoryTiles;
